module.exports = __webpack_public_path__ + "img/logo-light.f658a744.svg";